import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import DemoScheduler from "./DemoScheduler";
import { track } from "@/lib/track";

// Primary conversion CTA: same label and risk-reducing note everywhere on the page
interface DemoCTAProps {
  /** Page section the CTA lives in, for funnel tracking */
  location: string;
  /** Pre-selects the application in the demo form (must match a select value) */
  defaultApplication?: string;
}

const DemoCTA = ({ location, defaultApplication }: DemoCTAProps) => {
  const { t } = useTranslation();
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <div className="flex flex-col items-center gap-3">
      <Button size="lg" className="group w-full sm:w-auto" onClick={() => { track("cta_click", { location }); setDemoOpen(true); }}>
        {t("hero.cta")}
        <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
      </Button>
      <p className="text-sm text-muted-foreground text-center">{t("hero.ctaNote")}</p>
      <DemoScheduler open={demoOpen} onOpenChange={setDemoOpen} source={location} defaultApplication={defaultApplication} />
    </div>
  );
};

export default DemoCTA;
